<template>
  <v-dialog width="600" v-model="dialog">
    <gg-card>
      <gg-toolbar @close="close">
        Reset zone
      </gg-toolbar>

      <gg-card-text>
        <p class="mb-2">
          Resetting your zone file will erase any modifications you have made to your zone records. The system will
          attempt to preserve TXT records. However, we recommend that you take note of any records you want to save.
        </p>
        <p class="mb-0">
          Are you sure you want to erase all entries and revert to the default state?
        </p>
      </gg-card-text>
      <v-card-actions class="justify-end">
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn :loading="loading" @click="resetZone">Reset</gg-btn>
      </v-card-actions>
    </gg-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ResetModal',
  mixins: [modalMixin],
  props: {
    domain: {
      type: String,
      required: true
    },
    username: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions(['cpanel_api2', 'reportError', 'reportSuccess']),
    async resetZone () {
      this.loading = true
      const data = {
        api2_module: 'ZoneEdit',
        api2_method: 'resetzone',
        domain: this.domain,
        _username: this.username || this.$route.query.user,
      }
      try {
        await this.cpanel_api2(data)
        this.reportSuccess(`You successfully reset the zone for “${this.domain}”.`)
        this.loading = false
        this.$emit('reset-complete')
        this.close()
      } catch (e) {
        this.loading = false
        this.reportError(e.resultmsg)
      }
    }
  },
}
</script>
